import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';
import { Phase } from '../../../Helper/ApiHelper/KeyValueNetworkHelper';
import {
  CatalogProject,
  CopyCatalogInfo,
  createNewEpCatalogForPropertyFromExcel,
  deleteEpCatalogForPhase,
  replaceEpCatalogForPhaseFromExcel
} from '../../../Helper/ApiHelper/LvEpNetworkHelper';
import {
  ACCEPTED_FORMATS_EXCEL,
  DURATION_NOTIFICATION_ERROR_LONG
} from '../../../Helper/Statics/Constants';
import { isBefore } from '../../../Helper/Util/TimelineStepHelper';
import BeeLinkButton from '../../Atoms/BeeLinkButton';
import { FileUploadType } from '../../../Helper/ApiHelper/types';
import BeeDeletionDialog from '../Dialogs/BeeDeletionDialog';
import BeeUploadDialog from '../Dialogs/BeeUploadDialog';
import './EpLvPhase.scss';
import AlphaConfigEpTreeDialog from '../Dialogs/AlphaConfigEpTreeDialog';
import { errorMsgToString } from '../../../Helper/ApiHelper/ErrorMessages';
import AlphaEpCatalogSelectDialog from '../Dialogs/AlphaEpCatalogSelectDialog';
import { EpCatalogPickerSelection } from '../Dialogs/AlphaEpCatalogPickerStep';

type EpLvPhaseProps = {
  phase?: Phase;
  epTree: any;
  allEpCatalogs: CopyCatalogInfo[];
  onSelectEpCatalog: (catalog: EpCatalogPickerSelection) => void;
  onAdaptData: (headline: string, message: string) => void;
};

export function EpLvPhase({
  phase,
  epTree,
  allEpCatalogs,
  onAdaptData,
  onSelectEpCatalog
}: EpLvPhaseProps) {
  //states
  const [selectEpCatalogVisible, setSelectEpCatalogVisible] =
    useState<boolean>(false);

  const [deletionVisible, setDeletionVisible] = useState<boolean>(false);
  const [currEpTreeVisible, setcurrEpTreeVisible] = useState<boolean>(false);
  //refs
  const toast = useRef<Toast>(null);

  function replaceEpCatalog() {
    setSelectEpCatalogVisible(true);
  }

  /////////////
  // DIALOGS //
  /////////////

  function injectDeletionConfirmationDialog() {
    if (phase && phase.id && phase.ep && phase.ep.id) {
      const catalogId = phase.ep.id;
      return (
        <BeeDeletionDialog
          visible={deletionVisible}
          message={
            'Möchten Sie den EP-Katalog dieser Phase wirklich löschen? Hierdurch werden alle hinterlegten Gebäude-LVs dieser Phase ebenfalls gelöscht. '
          }
          messageIcon={'pi pi-exclamation-triangle'}
          acceptLabel={'Löschen'}
          rejectLabel={'Abbrechen'}
          header={'EP-Katalog löschen'}
          type={'primary'}
          onAccept={() => deleteEpCatalog(phase.id, catalogId)}
          onReject={() => setDeletionVisible(false)}
          onHide={() => setDeletionVisible(false)}
        />
      );
    } else {
      return null;
    }
  }
  function injectCurrentEpTreeDialog() {
    if (phase && phase.id && phase.ep && phase.ep.id) {
      return (
        <AlphaConfigEpTreeDialog
          visible={currEpTreeVisible}
          phase={phase}
          data={epTree}
          readOnly={false}
          onDelete={() => setDeletionVisible(true)}
          onReplace={() => replaceEpCatalog()}
          onHide={() => setcurrEpTreeVisible(false)}
          onDownload={() => downloadEpCatalog(phase.id)}
        />
      );
    } else {
      return null;
    }
  }

  ///////////////
  // UI HELPER //
  ///////////////

  function adaptData(headline: string, message: string) {
    if (onAdaptData) {
      onAdaptData(headline, message);
    }
  }

  function downloadEpCatalog(phaseId: String) {
    toast.current?.show({
      severity: 'info',
      summary: 'Download noch nicht implementiert',
      detail: 'Diese Funktion ist leider noch nicht implementiert',
      sticky: false,
      closable: true,
      life: DURATION_NOTIFICATION_ERROR_LONG
    });
    // readEpCatalogAsExcelForProperty(phaseId).catch((error) => {
    //   toast.current?.show({
    //     severity: 'error',
    //     summary: 'Download nicht möglich',
    //     detail:
    //       'Der EP-Katalog kann leider nicht heruntergeladen werden. ' + error,
    //     sticky: false,
    //     closable: true,
    //     life: DURATION_NOTIFICATION_ERROR_LONG
    //   });
    // });
  }

  /*  function uploadEpCatalog(phaseId: String, file: FileUploadType) {
    setUploadProgressVisible(true);
    createNewEpCatalogForPropertyFromExcel(phaseId, file.file)
      .then(() => {
        setUploadProgressVisible(false);
        setUploadVisible(false);
        const headline = 'EP-Katalog angepast';
        const message =
          'Der EP-Katalog wurde erfolgreich hochgeladen. Sie können nun die LVs der Liegenschaften hochladen.';
        adaptData(headline, message);
      })
      .catch((error) => {
        setUploadProgressVisible(false);
        setUploadError('Der EP-Katalog kann leider nicht hochgeladen werden.');
        toast.current?.show({
          severity: 'error',
          summary: 'Upload nicht möglich',
          detail:
            'Der EP-Katalog kann leider nicht hochgeladen werden. ' + error,
          sticky: false,
          closable: true,
          life: DURATION_NOTIFICATION_ERROR_LONG
        });
      });
  } */
  /*  function uploadReplaceEpCatalog(phaseId: String, file: FileUploadType) {
    setUploadReplaceProgressVisible(true);
    replaceEpCatalogForPhaseFromExcel(phaseId, file.file)
      .then(() => {
        setUploadReplaceProgressVisible(false);
        setUploadReplaceVisible(false);
        const headline = 'EP-Katalog ersetzt';
        const message = 'Der EP-Katalog wurde erfolgreich ersetzt.';
        adaptData(headline, message);
      })
      .catch((error) => {
        setUploadReplaceProgressVisible(false);
        setUploadReplaceError(error);
      });
  } */

  function deleteEpCatalog(phaseId: String, catalogId: String) {
    deleteEpCatalogForPhase(phaseId, catalogId)
      .then(() => {
        const headline = 'EP-Katalog gelöscht';
        const message =
          'Der EP-Katalog wurde erfolgreich gelöscht. Um die Bepreisung der Dienstleister zu ermöglichen, laden Sie bitte einen neuen EP Katalog hoch.';
        adaptData(headline, message);
        if (currEpTreeVisible) {
          setcurrEpTreeVisible(false);
        }
      })
      .catch((error) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Löschen fehlgeschlagen',
          detail:
            'Der EP-Katalog kann leider nicht gelöscht werden. Bitte versuchen Sie es später erneut. ' +
            error,
          sticky: false,
          closable: true,
          life: DURATION_NOTIFICATION_ERROR_LONG
        });
      });
  }

  ////////////////
  // UI METHODS //
  ////////////////

  const injectUI = () => {
    if (phase) {
      if (phase.end && isBefore(phase.end, new Date())) {
        // future
        if (phase.ep && phase.ep.id) {
          return injectPhaseNotDoneWithData(phase);
        } else {
          return injectPhaseNotDoneNoData(phase);
        }
      } else {
        return injectPhaseDone(phase);
      }
    } // render empty otherwise!!
  };

  function injectPhaseDone(phase: Phase) {
    const start = phase && phase.start ? new Date(phase.start) : null;
    const end = phase && phase.end ? new Date(phase.end) : null;

    const epCatalogName =
      phase.ep && (phase.ep as CopyCatalogInfo)?.catalogName
        ? (phase.ep as CopyCatalogInfo).catalogName
        : null;
    return (
      <div>
        <div>{phase.title}</div>
        <div className={'ep-lv-phase-date flex'}>
          <span>
            {start ? start.toLocaleDateString('de-DE') + ' - ' : null}
          </span>{' '}
          <span>{end ? ' ' + end.toLocaleDateString('de-DE') : null}</span>
        </div>
        {phase.ep && phase.ep.id ? (
          <div className={'ep-lv-phase-epBtn download'}>
            <BeeLinkButton
              label={epCatalogName ?? 'EP-Katalog'}
              type={'secondary'}
              onClick={() => setcurrEpTreeVisible(true)}
            />
          </div>
        ) : null}
      </div>
    );
  }

  function injectPhaseNotDoneNoData(phase: Phase) {
    const start = phase && phase.start ? new Date(phase.start) : null;
    const end = phase && phase.end ? new Date(phase.end) : null;
    return (
      <div>
        <div>{phase.title}</div>
        <div className={'ep-lv-phase-date flex'}>
          <span>
            {start ? start.toLocaleDateString('de-DE') + ' - ' : null}
          </span>{' '}
          <span>{end ? ' ' + end.toLocaleDateString('de-DE') : null}</span>
        </div>
        {!(phase.ep && phase.ep.id) ? (
          <div className={'ep-lv-phase-epBtn'}>
            <BeeLinkButton
              label={
                <>
                  <i className={'pi pi-upload'}></i>
                  <span>{'EP-Katalog auswählen'}</span>
                </>
              }
              type={'secondary'}
              onClick={() => setSelectEpCatalogVisible(true)}
            />{' '}
          </div>
        ) : null}
      </div>
    );
  }

  function injectPhaseNotDoneWithData(phase: Phase) {
    const start = phase && phase.start ? new Date(phase.start) : null;
    const phaseStarted: boolean =
      start && isBefore(new Date(), new Date(start)) ? true : false;
    const end = phase && phase.end ? new Date(phase.end) : null;
    const filename: any =
      phase.ep && phase.ep.filename ? phase.ep.filename : null;

    const epCatalogName =
      phase.ep && (phase.ep as CopyCatalogInfo)?.catalogName
        ? (phase.ep as CopyCatalogInfo).catalogName
        : null;
    return (
      <div>
        <div>{phase.title}</div>
        <div className={'ep-lv-phase-date flex'}>
          <span>
            {start ? start.toLocaleDateString('de-DE') + ' - ' : null}
          </span>{' '}
          <span>{end ? ' ' + end.toLocaleDateString('de-DE') : null}</span>
        </div>
        {phase.ep && phase.ep.id ? (
          <div className={'ep-lv-phase-epBtn grid download'}>
            <div className={'col download-btn'}>
              <BeeLinkButton
                label={epCatalogName ?? 'EP-Katalog'}
                type={'secondary'}
                onClick={() => setcurrEpTreeVisible(true)}
              />
            </div>{' '}
            {!phaseStarted ? (
              <div className={'col col-fixed delete-btn'}>
                <BeeLinkButton
                  label={<i className={'pi pi-trash'}></i>}
                  type={'danger'}
                  onClick={() => setDeletionVisible(true)}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
  function injectSelectEpCatalogDialog() {
    return (
      <AlphaEpCatalogSelectDialog
        visible={selectEpCatalogVisible}
        header="EP-Katalog auswählen"
        catalogs={allEpCatalogs}
        readOnly={false}
        onHide={() => setSelectEpCatalogVisible(false)}
        onConfirm={(selection) => {
          setSelectEpCatalogVisible(false);
          onSelectEpCatalog(selection);
        }}
      />
    );
  }

  return (
    <div>
      <Toast ref={toast} position={'top-right'} />
      {injectUI()}
      {selectEpCatalogVisible ? injectSelectEpCatalogDialog() : null}
      {deletionVisible ? injectDeletionConfirmationDialog() : null}
      {currEpTreeVisible ? injectCurrentEpTreeDialog() : null}
    </div>
  );
}

export default EpLvPhase;
